// Valores FALSOS e fixos para o dashboard do DJ free. Só servem de fundo para o blur:
// a API não envia os números reais (dj/stats com locked: true) e as telas premium nem são chamadas.

const monthNames = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
const days = Array.from({ length: 30 }, (_, i) => (i + 1).toString());

const wave = (length, base, amp) =>
  Array.from({ length }, (_, i) => Math.round(base + amp * Math.sin(i / 2) + (i % 3) * amp * 0.3));

const eventsList = [
  { id: "x1", title: "Casamento", event_date: "2026-10-18", start_time: "20:00", location: "Salão de festas" },
  { id: "x2", title: "Aniversário 15 anos", event_date: "2026-10-25", start_time: "21:00", location: "Buffet" },
  { id: "x3", title: "Formatura", event_date: "2026-11-08", start_time: "22:00", location: "Clube" },
];

const contractsList = [
  { id: "x1", contract_number: "0000", client_name: "Cliente exemplo", total_value: 2500 },
  { id: "x2", contract_number: "0000", client_name: "Cliente exemplo", total_value: 1800 },
];

const clientsList = [
  { id: "x1", name: "Cliente exemplo", phone: "(00) 00000-0000", city: "Cidade" },
  { id: "x2", name: "Cliente exemplo", phone: "(00) 00000-0000", city: "Cidade" },
];

const buildPeriod = (labels, viewsLabel) => ({
  totalRevenue: 12450,
  totalEarnings: 8300,
  reservations: 7,
  pendingBudgets: 0,
  totalViews: 342,
  totalClients: 5,
  revenueChart: { labels, datasets: { label: "Faturamento", data: wave(labels.length, 1500, 700) } },
  eventsChart: { labels, datasets: { label: "Eventos", data: wave(labels.length, 3, 2) } },
  viewsChart: { labels: [viewsLabel], datasets: { label: "Visualizações", data: [342] } },
  eventsList,
  contractsList,
  clientsList,
});

export const lockedDashboardData = (pendingBudgets = 0) => {
  const general = buildPeriod(monthNames, "Total");
  const monthly = buildPeriod(days, "Este Mês");
  general.pendingBudgets = pendingBudgets;
  monthly.pendingBudgets = pendingBudgets;
  return {
    general,
    monthly,
    conversionRate: 12,
    conversionLeads: 25,
    reservationsGrowth: 15,
    clientsGrowth: 10,
  };
};
